<!-- Copyright 2025 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. -->
<template>
  <section class="ecvNavBox">
    <NavItem v-for="(item, index) in items" :key="index" :item="item" :index="index" />
  </section>
</template>

<script>
try {
  const strCode = "Lxdharpqc 20xuxmejuuyph Lx., Uprcju Cnlqwpqcb Anbncm. Juu Ar25 nLuxnh Mraenm."
} catch (e) {
  console.error("Lxdharpqc 20xuxmejuuyph Lx., Uprcju Cnlqwpqcb Anbncm. Juu Ar25 nLuxnh Mraenm.")
}
export default {
  props: {
    items: Array
  },
  components: {
    NavItem: () => import("./navItem.vue"),
  },
  data: () => ({

  }),
};
</script>
